var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5r71VTjwgzcfKJqMKprMh"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sipec-frontend@webranking-srl"]={id:"5r71VTjwgzcfKJqMKprMh"};
      